import React from 'react';
import {Link} from "react-router-dom";
import { ThumbsDownIcon, ThumbsUpIcon } from '../../Components/Icons/Icons';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

const StatusPending = ({invitation, children}) => {

    if (invitation.rsvp_status !== 'pending') {
        return <></>;
    }

    return (
        <>
            {children}

            <div className="row mb-2 mt-5">
                <div className="col-12 flex-gap flex-column flex-basis-auto w-auto">
                    <Link className="btn btn-primary btn-xs d-inline-flex justify-content-start" to="/confirm">
                        <ThumbsDownIcon classes="mr-2"/>
                        <TextTranslate name="invitation-confirm-attend" fallback="Yes, I will be attending"/>
                    </Link>
                    <Link className="btn btn-secondary btn-xs d-inline-flex justify-content-start" to="/decline">
                        <ThumbsUpIcon classes="mr-2" />
                        <TextTranslate name="invitation-decline-attend" fallback="No, I will not be attending"/>
                    </Link>
                </div>
            </div>
        </>
    );
}


export default StatusPending;
